export default "__VITE_ASSET__Bo9i2lbP__"